import React, {useState, useEffect} from 'react';

function CartInputCoupon(props) { 
  const [ErrorMsg, setErrorMsg] = useState(() => {
    const initialState = initErrorMsg();
    return initialState;
  }); 
  
  function initErrorMsg() {
    //console.log("INIT");
     if (!props.errList || props.errList.length === 0)
      return "";
    let txt = "";
    let errList = props.errList.filter((el) => el.id === props.name);
    if (errList.length > 0) {
      errList.forEach((el) => txt += el.msg+ " ");
    }   
    const initialState = txt;
    return initialState;
  };

  useEffect(() => {
    if (ErrorMsg === "") {
      let txt = initErrorMsg();
      if (txt !== "")
        setErrorMsg(txt);
    }
  }, [props.errList]);

  function checkField(ev) {
    props.change(ev.target.value);
    if (props.required && ev.target.value.length === 0) {
      setErrorMsg("Si prega di non lasciare il campo vuoto");
    } else setErrorMsg("");
  }

  function apply() {
    setErrorMsg("");
    props.apply();
  }

  const startingStyle = {
    border: "1px solid #B3B3B3",
  };
  const validStyle = {
    border: "1px solid green",
  };
  const invalidStyle = {
    border: "1px solid red",
  };
  function setStyle() {
    if (!props.required) return startingStyle;
    if (props.value.length === 0 && ErrorMsg.length === 0) return startingStyle;
    if (ErrorMsg.length === 0) return validStyle;
    else return invalidStyle;
  }

  function labelUrl(label, urlText, url) {
    let txt =
      label + " (<a target='_self' href='" + url + "'>" + urlText + "</a>)";
    return { __html: txt };
  }

  function composeLabel(labelTxt) {
    if (props.url && props.url.length > 0) {
      return (
        <label
          dangerouslySetInnerHTML={labelUrl(labelTxt, props.urlText, props.url)}
        />
      );
    } else return <label>{labelTxt}</label>;
  }

  let label = props.lbl;
  if (props.required === true && label.length > 0) label += " *";

  return (
    <div className={props.cssClass}>
      {props.labelRight === true ? null : composeLabel(label)}

      <div className="input_sconto_cart">
        <input
          type="text"
          name={props.name}
          value={props.value}
          onChange={(e) => checkField(e)}
          style={setStyle()}
        />
        <input type="button" value={props.btnLbl} onClick={() => apply()} />
      </div>

      {props.labelRight === true ? composeLabel(label) : null}
      {props.imgUrl && props.imgUrl.length > 0 ? (
        <img src={props.imgUrl} alt={props.imgAlt} title={props.imgAlt} />
      ) : null}

      {ErrorMsg.length > 0 ? (
        <div className="campo_vuoto_cart">
          <p>{ErrorMsg}</p>
        </div>
      ) : null}
    </div>
  );
}

export default CartInputCoupon;